//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SpecialistCard",
  emits: ['openModal'],
  props: {
    name: {
      type: String,
      required: true,
    },
    specialization: {
      type: [String, null],
      default: ""
    },
    stores: {
      type: Array,
      requared: false,
      default() {
        return []
      },

    },
    image: {
      type: [String, Number],
      required: false,
      default() {
        return ''
      }
    },
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      requared: false,
      default() {
        return 'Записаться'
      }
    }
  },

  data: function () {
    return {
      product: {}
    }
  },
  methods: {
    openModalBottom(id) {
      this.$emit('openModalBottom', id)
    },
    openModalCard(id) {
      this.$emit('openModalCard', id)
    }
  },
  computed: {
    setSpecialization() {
      let specialization = this.specialization || "";

      if ((specialization || '').length > 25) {
        return `${specialization.substring(0, 20)}...`;
      }

      return specialization
    },
  },
}

